import { FormatConstants } from 'services/keyConstants';

export const customerFeedbackOptions = [
  "Generate-Link",
  "Fill-Customer-Feedback",
  "Generate-Link-Invite",
];

export const getStatusTypes = (type) => {
  switch (type) {
    case FormatConstants.FEEDBACK.INTERNAL_FEEDBACK:
      return {
        filteredData: {
          page: 1,
          totalPage: 1,
          status: "",
        },
        defaultOptionData: {
          statusOptions: [
            { label: "Pending", value: "Pending" },
            { label: "Positive", value: "Positive" },
            { label: "Negative", value: "Negative" },
          ]
        }
      };
      break;

    case FormatConstants.FEEDBACK.EXTERNAL_FEEDBACK:
      return {
        filteredData: {
          page: 1,
          totalPage: 1,
          type: "Generate-Link",
          status: "",
        },
        defaultOptionData: {
          statusOptions: [
            { label: "Pending", value: "Pending" },
            { label: "Positive", value: "Positive" },
            { label: "Negative", value: "Negative" },
          ],
          typeOptions: [
            { label: "Generate-Link", value: "Generate-Link" },
            { label: "Fill-Customer-Feedback", value: "Fill-Customer-Feedback" },
          ]
        }
      };
      break;

    // Default case if no matching type is found
    default:
      return {
        filteredData: {
          status: "Unknown",
          documentName: "Unknown Document",
        },
        defaultOptionData: {
          statusOptions: []
        }
      };
  }
};
